import { IColor, IVector3, LineType } from "../../api.js";
import { DebugVisualizer } from "../debug/visualizers/DebugVisualizer.js";
import { icolor_to_col4, vector_3 } from "../utility/Conversion.js";
const COLORS = {
    BLUE: new IColor(0, 0, 1),
    RED: new IColor(1, 0, 0)
};
export class ReflectionProbeVisualizer extends DebugVisualizer {
    constructor(_probe, _viewer) {
        super(_viewer);
        this._probe = _probe;
        this._viewer = _viewer;
        this.update();
    }
    update() {
        this.remove_lines(0);
        let index = 0;
        index = this.draw_source_objects(index);
        this.draw_target_objects(index);
    }
    draw_source_objects(index) {
        const color = icolor_to_col4(COLORS.BLUE);
        const thickness = 0.02;
        const source_objects = this._probe.source_objects.map(id => this._viewer.viewer_scene.objects.get(id));
        source_objects.forEach(objects => {
            const position = objects.transform_offset_with_world_matrix();
            this.draw_line(index++, position, vector_3(this._probe.position), color, thickness, LineType.DASHED);
        });
        return index;
    }
    draw_target_objects(index) {
        const color = icolor_to_col4(COLORS.RED);
        const thickness = 0.02;
        const target_objects = this._probe.target_objects.map(id => this._viewer.viewer_scene.objects.get(id));
        target_objects.forEach(objects => {
            const position = objects.transform_offset_with_world_matrix();
            const distance = IVector3.distance(position, this._probe.position);
            if (distance < 0.1)
                return;
            this.draw_line(index++, position, vector_3(this._probe.position), color, thickness, LineType.DASHED);
        });
        return index;
    }
}
//# sourceMappingURL=ReflectionProbeVisualizer.js.map